import React, { useState,useEffect } from "react";
import axios from "axios";
import { Link,useNavigate } from "react-router-dom";
import API_URLS from "../config/apiConfig";
import swal from 'sweetalert';
import { ClipLoader } from "react-spinners";
import Pagination from "../components/Pagination";

const Courses = () => {
    
    const authToken = localStorage.getItem("token");
    const navigate = useNavigate();
    const [listingData, setListingData] = useState([]);
    const [pagination, setPagination] = useState({
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total: 0,
    });
    
    const [loading, setLoading] = useState(true);
     // Fetch categories from the server

    const fetchlistingData = async (page = 1) => {
      try {
        setLoading(true);
        
        const response = await axios.post(API_URLS.COURSES+`?page=${page}`,null, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        console.log(response.data);
        if(response.data.success==1){
        setListingData(response.data.listData.data);
        console.log(listingData);
        setPagination({
          current_page: response.data.listData.current_page,
          last_page: response.data.listData.last_page,
          per_page: response.data.listData.per_page,
          total: response.data.listData.total,
        });
        }else{
        swal("Error", response.data.message, "error");  
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };
    useEffect(() => {
    fetchlistingData();
  }, []);
 

  // Change page
  const handlePageChange = (page) => {
    fetchlistingData(page);
  };

  const handleEdit = (course) => {
    navigate('/manager/course/add', { state: { course } }); // Pass course data to the form page
  };

  const handleDelete = async (id) => {
    try {
      if (window.confirm("Are you sure you want to delete this record?")) {
      
         const response = await axios.post(API_URLS.COURSES_DELETE+`?id=${id}`,null, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
      
        if(response.data.success==1){
          swal("Success", response.data.message, "success").then(() => {
            fetchlistingData(pagination.current_page); // Refresh the list after deletion
          });
         
          }else{
          swal("Error", response.data.message, "error");  
          }
          
      }
    } catch (error) {
    
      swal("Error", "Failed, Please try again.", "error");  
     
    }
  };
    return (
     <>
       {loading && (
                             <div className="loader-overlay">
                                 <ClipLoader color="#08A9E6" loading={loading} size={50} />
                             </div>
                         )}
         <div className="container-fluid mt-5">
         <div className="row">
           <div className="col-12">
      <h2 className="mb-4 float-start">Courses</h2>
      <Link to="/manager/course/add" className="btn btn-primary float-end mb-2">Create New Course</Link>
      </div>
         </div>
      {listingData.length > 0 ? (
      <div className="row">
          { listingData.map((listItem, index) => (
          <div className="col-lg-3 col-md-6" key={listItem.id}>
                        <div className="courses-item">
                            <Link to={`/manager/course-details?course_id=${listItem.id}`} className="text-center">
                                <img src={listItem.image_thumb_url?listItem.image_thumb_url: "/assets/images/no-image.png"} alt="Courses"/>
                            </Link>
                            <div className="content">
                              
                                <h3><Link to={`/manager/course-details?course_id=${listItem.id}`} >{listItem.course_name}</Link></h3>
                                <ul className="course-list">
                                    {/*<li><i className="ri-time-fill"></i> 10 hr 07 min</li>*/}
                                    <li><i className="ri-vidicon-fill"></i> {listItem.chapters_count} chapters</li>
                                </ul>
                                <div className="bottom-content">
                              <span   className="cursor-pointer" onClick={() => handleEdit(listItem)}><i className="fa fa-pencil"></i></span>
                              <span  className="cursor-pointer ms-2" onClick={() => handleDelete(listItem.id)} ><i className="fa fa-trash"></i></span>
           
                                </div>
                            </div>
                        </div>
                    </div>))}
        </div> ):(
          <div className="row">
            <div className="col-12 text-center" > No Record available</div>
          </div>
        )}
      
     {/* <table className="table table-bordered table-hover">
        <thead className="table-primary">
          <tr>
            <th style={{width:"10%"}}>#</th>
            <th style={{width:"80%"}}>Course Name</th>
            <th style={{width:"10%"}}>Action</th>
          </tr>
        </thead>
        <tbody>
          {listingData.length > 0 ? (
            listingData.map((listItem, index) => (
              <tr key={listItem.id}>
                <td>{(pagination.current_page-1)*pagination.per_page+index + 1}.</td>
                <td>{listItem.course_name}</td>
                <td>
                  <span   className="cursor-pointer" onClick={() => handleEdit(listItem)}><i className="fa fa-pencil"></i></span>
                  
                  <span  className="cursor-pointer" onClick={() => handleDelete(listItem.id)} className="ms-2"><i className="fa fa-trash"></i></span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center">
                No Record available
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {/* Pagination Component */}
      {pagination.last_page > 1 && (
      <Pagination
            currentPage={pagination.current_page}
            lastPage={pagination.last_page}
            onPageChange={handlePageChange}
          />)}
    </div>
     </>);
}
export default Courses;